<template>
  <mdb-container>
    <Vedheader></Vedheader>
    <mdb-alert color="danger" v-if="error" class="mt-3">
      {{ error }}
    </mdb-alert>

    <mdb-card class="card-body" style="margin-top: 1rem;">
      <mdb-card-title class="h3 indigo-text">OFFRIR LE QUÉBEC COMME DESTINATION VACANCES ET INTRODUCTION AU CANADA</mdb-card-title>
      <mdb-card-text>
        Ce programme de formation vous permettra d'approfondir vos connaissances au sujet des différentes offres touristiques québécoises et canadiennes tout en vous familiarisant avec les techniques et meilleures pratiques pour une approche dynamique de contenu sur le web et les médias sociaux.
      </mdb-card-text>
      <mdb-card-text>
        Votre portail sera mis à jour constamment, c'est-à-dire qu'on y ajoutera au fur et à mesure des webinaires à visionner jusqu'à concurrence de plus ou moins 50 heures de cours. Le programme est divisé en quatre sections distinctes:

        <ul style="padding-top:10px;">
          <li><strong>Volet 1</strong> - Vendre le Québec et ses environs & apprendre les incontournables : une solution gagnante pour les agents de voyages</li>
          <li><strong>Volet 2</strong> - Connaître les forfaits et produits touristiques disponibles aux conseillers en voyages</li>
          <li><strong>Volet 3</strong> - Maîtriser les techniques de ventes et du marketing numérique – web et médias sociaux</li>
          <li><strong>Volet 4</strong> - FAQ - Examen final pour l'obtention de la certification</li>
        </ul>
      </mdb-card-text>
      <mdb-card-text>
        L'ordre dans lequel vous visionner les webinaires importe peu. Par contre, assurez-vous de bien les écouter, du début à la fin afin qu'ils soient comptabilisés à vos heures de cours suivies. De plus, si vous étiez des nôtres lors de formations en direct avec certains de nos partenaires, il vous sera possible de l'indiquer afin de vous éviter de devoir l'écouter à nouveau. Par contre, n'oubliez pas de télécharger les divers documents disponibles, ce sont des outils forts utiles pour vous et vos clients.
        <br /><br />
        Pour consulter le plan de cours complet, <a href="https://files.expertenvoyages.com/vedformation/public/plan_de_cours.pdf" target="_blank">veuillez cliquer ici.</a>
        <br /><br />
        Merci encore de nous faire confiance quant à la formation continue. Voyages en direct vous souhaite un bon visionnement !
      </mdb-card-text>
    </mdb-card>
    <mdb-card class="card-body" style="margin-top: 1rem;" v-if="isLoading">
      <div class="d-flex justify-content-center">
        <mdb-spinner big color="blue" />
      </div>
    </mdb-card>

    <mdb-container v-for="module in videos" :key="module.id">
      <mdb-card class="mt-5" narrow>
        <mdb-view gradient="blue" cascade>
          <h2 class="card-header-title">{{module.name}}</h2>
          <p class="mb-0"></p>
        </mdb-view>
        <mdb-card-body class="text-left mt-4 mb-4 m-4" cascade >
          <mdb-card-text>
            {{module.description}}
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>

      <mdb-card-body class="text-center" cascade>
        <mdb-card class="mt-3" v-for="section in module.cats" :key="section.catid">
          <mdb-card-header color="blue lighten-2"><strong>{{section.catname}}</strong><mdb-icon icon="list" class="float-right pointer" size="2x" v-if="displaymode=='list'" @click.native="toggledisplaymode('grid')" /><mdb-icon icon="th-large" class="float-right pointer" size="2x" v-if="displaymode=='grid'" @click.native="toggledisplaymode('list')" /></mdb-card-header>
            <h5 v-if="section.catdescription" class="mt-4 ml-4 mr-1 text-left">{{section.catdescription}}</h5>
          <mdb-row class="card-body" v-if="displaymode=='grid'">
            <formationtile v-for="video in section.videos" :key="video.ident" v-bind:title="video.title" v-bind:duration="video.duration" v-bind:intro="video.introtext" v-bind:iscompleted="video.iscompleted" v-bind:ident="video.ident" v-bind:image="video.image"></formationtile>
          </mdb-row>
          <mdb-row class="card-body" v-if="displaymode=='list'">
            <mdb-tbl class="w-100">
              <mdb-tbl-head>
                <tr>
                  <th class="text-left">Titre</th>
                  <th class="text-left">Durée</th>
                  <th>&nbsp;</th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr v-for="video in section.videos" :key="video.ident">
                  <td class="align-middle text-left">{{video.title}}</td>
                  <td class="align-middle text-left">{{video.duration}}</td>
                  <td><mdb-btn size="sm" v-on:click="gotoformation(video.ident)">Voir</mdb-btn></td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>
          </mdb-row>
        </mdb-card>
      </mdb-card-body>
    </mdb-container>

    <mdb-container v-if="this.$store.state.exampassed">
      <mdb-card class="mt-5" narrow>
        <mdb-view gradient="blue" cascade>
          <h2 class="card-header-title">Volet 4 - examen final</h2>
          <p class="mb-0"></p>
        </mdb-view>
        <mdb-card-body class="text-left mt-4 mb-4 m-4" cascade >
          <mdb-card-text>
            <h4>Vous avez réussi l'examen avec succès</h4>
            <mdb-btn size="lg" color="default" :href="diplomelink" target="_blank" tag="a">Obtenir mon diplôme</mdb-btn>
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>
    <mdb-container v-else>
      <mdb-card class="mt-5" narrow>
        <mdb-view gradient="blue" cascade>
          <h2 class="card-header-title">Volet 4 - examen final</h2>
          <p class="mb-0"></p>
        </mdb-view>
        <mdb-card-body class="text-left mt-4 mb-4 m-4" cascade >
          <mdb-card-text>
            <p>Vous pouvez désormais accéder à l’examen final qui validera toutes les connaissances acquises durant cette formation.</p>
            <mdb-btn size="lg" color="default" v-on:click="gotoexam">Accéder à l'examen</mdb-btn>
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>

    <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
      <div class="footer-copyright text-center py-3">
        <mdb-container fluid>
          &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
        </mdb-container>
      </div>
    </mdb-footer>
  </mdb-container>
</template>

<script>
  import Vedheader from '@/components/Header.vue';
  import {
    mdbContainer,
    mdbFooter,
    mdbCard,
    mdbCardTitle,
    mdbCardText,
    mdbRow,
    mdbCardHeader,
    mdbAlert,
    mdbSpinner,
    mdbView,
    mdbCardBody,
    mdbIcon,
    mdbTbl,
    mdbTblBody,
    mdbBtn,
    mdbTblHead,
  } from 'mdbvue';
  import Apicall from '../libs/Apicall';
  import formationtile from '../components/formationtile.vue';
  import config from '../libs/config';

  export default {
    name: 'Home',
    components: {
      Vedheader,
      mdbContainer,
      mdbFooter,
      mdbCard,
      mdbCardTitle,
      mdbCardText,
      mdbRow,
      mdbCardHeader,
      mdbAlert,
      mdbSpinner,
      formationtile,
      mdbView,
      mdbCardBody,
      mdbIcon,
      mdbTbl,
      mdbTblBody,
      mdbBtn,
      mdbTblHead,
    },
    data() {
      return {
        videos: '',
        error: '',
        isLoading: true,
        displaymode: 'grid',
        diplomelink: '',
      };
    },
    mounted() {
      this.getAndDisplayFormations();
      const saveddisplaymode = window.localStorage.getItem('displaymode');
      if (saveddisplaymode) {
        this.displaymode = saveddisplaymode;
      }
      const domain = config.basedomain;
      this.diplomelink = `${domain}download/diplome/${this.$store.state.bearer}.jpg`;
    },
    methods: {
      getAndDisplayFormations() {
        const api = new Apicall();
        const self = this;
        api.getAvailablesFormationsForMe().then((response) => {
          if (response.status === 'OK') {
            self.videos = response.data;
          } else {
            self.error = response.msg;
          }
          self.isLoading = false;
        });
      },

      toggledisplaymode(mode) {
        this.displaymode = mode;
        window.localStorage.setItem('displaymode', mode);
      },
      gotoformation(ident) {
        this.$router.push({ name: 'VideoDetails', params: { videoident: ident } });
      },
      gotoexam() {
        this.$router.push({ name: 'Exam' });
      },
      downloaddiplome() {
        alert('download diplôme');
      },
    },
  };
</script>

<style scoped>
  .pointer{
    cursor:pointer;
  }
</style>
